import { render, staticRenderFns } from "./DashboardQuoteStatus.vue?vue&type=template&id=8059f5a2&scoped=true"
import script from "./DashboardQuoteStatus.vue?vue&type=script&lang=js"
export * from "./DashboardQuoteStatus.vue?vue&type=script&lang=js"
import style0 from "./DashboardQuoteStatus.vue?vue&type=style&index=0&id=8059f5a2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8059f5a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8059f5a2')) {
      api.createRecord('8059f5a2', component.options)
    } else {
      api.reload('8059f5a2', component.options)
    }
    module.hot.accept("./DashboardQuoteStatus.vue?vue&type=template&id=8059f5a2&scoped=true", function () {
      api.rerender('8059f5a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardQuoteStatus.vue"
export default component.exports